import React from 'react'

import LoginForm from '../components/Authentication/login'

const LoginPage = (props) => {
  return <LoginForm />
}


export default LoginPage;